// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8792) return "main.b0bb69d6.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"2793":"a44659e1","2805":"32c410ba","8094":"7bdea643","8577":"46657d27","8703":"b0c8a2ae"}[chunkId] + ".chunk.css";
};